import React from "react";
import ContractSelection from "../logical/ContractSelection";

/**
 * Entry view for the Testklient (/testklient).
 * Renders the contract selection landing.
 */
function Testclient() {
  return <ContractSelection />;
}

export default Testclient;
